module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "yn3hptqv",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
};
